import { Component } from '@angular/core';

@Component({
  selector: 'app-cards6-examples-40',
  templateUrl: './cards6-examples-40.component.html'
})
export class Cards6Examples40Component {}
